import { BaseModel } from "./base.model";

export class KantoniDto extends BaseModel {
    sifra: number;
    kanton: string;
    drzzava: number | null;
}